import styled from 'styled-components';
import Button from '../../components/Button';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: #fff;
    min-height: 100vh;
    height: 100vh;

    @media (max-width: 800px) {
        height: 100%;
        min-height: 100%;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    max-width: 460px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 1rem 2rem 1rem 2rem;
    gap: 1.5rem;
`;

export const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-grow: 1;
`;

export const BorderImage = styled.div`
    border: 3px solid #FEF9ED;
    border-radius: 50%;
    padding: 1rem;
`;

export const Image = styled.div`
    width: 250px;
    height: 250px;
    background-image: url('/images/santa.png');
    background-size: cover;
    background-position: center;
    border-radius: 50%;
`;
export const StyledButton = styled(Button)`
    width: 100%;
`;

export const ButtonLabel = styled.span`
    width: 100%;
    padding-left: 1.4rem;
`;
